import ContentMasonry from 'Components/social-account/ContentMasonry'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchCompetitionContentThunk } from 'slices/competitionAnalysis/thunk'
import { AppDispatch, RootState } from 'store'
import { defaultCompetitionContentFilters } from 'types/competition-analysis'
import { generateUniqueKey } from 'utils/helpers'

const filters = defaultCompetitionContentFilters;

const CompetitionContentPreview = () => {

    const dispatch: AppDispatch = useDispatch();
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));

    const competitionContentData = useSelector((state: RootState) => state.competitionAnalysis.content?.filtered_lists[filterId]);
    const content = competitionContentData?.items ?? [];
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        dispatch(fetchCompetitionContentThunk({ filters })).finally(() => setLoading(false));
    }, [filters])

    return (
        <div className='dashboard-section'>
            <div className="dashboard-section-header">
                <h5>Your competitors recent content</h5>
                <Link className='dashboard-section-header-view-more' to={{ pathname: '/competitor', search: '?tab=content' }}>View All</Link>
            </div>
            <div className="dashboard-section-body">
                <ContentMasonry isLoading={loading} posts={content.map((c) => c.social_post)} />
                {
                    (!loading) && (content.length === 0) &&
                    <div className="d-flex w-100 justify-content-center align-items-center">
                        <div className="length-zero my-3">
                            <h3>Currently there is no content in your list!</h3>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CompetitionContentPreview